import { registerPlugin } from '@capacitor/core';

import type { IntuneNativePlugin } from './definitions';

const IntuneNative = registerPlugin<IntuneNativePlugin>('IntuneNative', {
  web: () => import('./web').then(m => new m.IntuneNativeWeb()),
});

export * from './definitions';
export { IntuneNative };
